import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { classNames } from 'utils/classNames';

import Section from './WorkspaceSidebarSection';
import TopSection from './WorkspaceSidebarTopSection';

const BASE_CLASS_NAME = 'WorkspaceSidebar';

class WorkspaceSidebar extends Component {
    static propTypes = {
        className: PropTypes.string,
        children: PropTypes.node.isRequired,
    };

    static defaultProps = {
        className: null,
    };

    static Section = Section;

    static TopSection = TopSection;

    render() {
        const className = classNames({
            [BASE_CLASS_NAME]: true,
            [this.props.className]: this.props.className,
        });

        return (
            <aside className={className}>
                <div className={`${BASE_CLASS_NAME}__content-wrapper`}>{this.props.children}</div>
            </aside>
        );
    }
}

export default WorkspaceSidebar;
